import { createFileRoute } from '@tanstack/react-router';
import { SwApprovals } from '@/features/smart-working/SwApprovals';

export const Route = createFileRoute('/_app/smart-working/approvals')({ component: SwApprovals });

// Coda approvazioni manager/HR: pagina propria, rifatta sul mockup `ScreenSWApprovals`
// (handoff §4.4) — tab, selezione multipla, planning batch e rail di contesto.
